import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolTip',
  props: {
    content: {},
    width: {},
    position: {}
  },
  setup(__props: any) {

const props = __props;
const tooltip = ref<HTMLDivElement | null>(null);
function showTooltip() {
  if (tooltip.value) {
    tooltip.value.style.display = "block";
  }
}

function hideTooltip() {
  if (tooltip.value) {
    tooltip.value.style.display = "none";
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "element",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (showTooltip())),
    onMouseout: _cache[1] || (_cache[1] = ($event: any) => (hideTooltip()))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", {
      class: _normalizeClass(["toolTip", {
        left: _ctx.position == 'left',
        right: _ctx.position == 'right',
        top: _ctx.position == 'top',
        topLeft: _ctx.position == 'topLeft',
      }]),
      ref_key: "tooltip",
      ref: tooltip,
      style: _normalizeStyle({ width: props.width ?? 'auto' })
    }, [
      _renderSlot(_ctx.$slots, "content"),
      _createTextVNode(_toDisplayString(props.content), 1)
    ], 6)
  ], 32))
}
}

})